import React from "react";

const Home = () => <div>GoStore Utility Tools</div>;

export default Home;
